import { render, staticRenderFns } from "./ViewFunds.vue?vue&type=template&id=f2938594&scoped=true"
import script from "./ViewFunds.vue?vue&type=script&lang=js"
export * from "./ViewFunds.vue?vue&type=script&lang=js"
import style0 from "./ViewFunds.vue?vue&type=style&index=0&id=f2938594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2938594",
  null
  
)

export default component.exports